// import React from 'react';
// import Slider from 'react-slick';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';
// import testmonial1 from '../Image/testmonial1.webp';
// import testmonial2 from '../Image/testmonial2.webp';
// import testmonial3 from '../Image/testmonial3.webp';
// import testmonial4 from '../Image/testmonial4.webp';
// import testmonial5 from '../Image/testmonial5.webp';
// import testmonial6 from '../Image/testmonial6.webp';
// import testmonial7 from '../Image/testmonial7.webp';
// import testmonial8 from '../Image/testmonial8.webp';
// import testmonial9 from '../Image/testmonial9.webp';
// import testmonial10 from '../Image/testmonial10.webp';
// import testmonial11 from '../Image/testmonial11.webp';
// import testmonial12 from '../Image/testmonial12.webp';
// import testmonial13 from '../Image/testmonial13.webp';
// import testmonial14 from '../Image/testmonial14.webp';
// import testmonial15 from '../Image/testmonial15.webp';
// import testmonial16 from '../Image/testmonial16.webp';
// import testmonial17 from '../Image/testmonial17.webp';
// import testmonial18 from '../Image/testmonial18.webp';
// import testmonial19 from '../Image/testmonial19.webp';
// import Avatar from '@mui/material/Avatar';
// import AvatarGroup from '@mui/material/AvatarGroup';
// import Rating from '@mui/material/Rating';
// import { ImQuotesLeft, ImQuotesRight } from "react-icons/im";

// const testimonials = [
//   {
//     img: testmonial16,
//     name: 'Palak Ashok Soshte',
//     designation:'B K Birla College',
//     text: 'During my internship, I gained hands-on experience with sensors, enhancing my understanding of robotics. I applied coursework concepts to solve real-world problems and developed strong technical skills in model creation. This experience improved my teamwork and communication skills, confirming my desire to pursue a career in robotics.',
//     alt: 'Palak Ashok Soshte ',
//     title: 'Palak Ashok Soshte ',
//     rating: 5,
//   },
//   {
//     img: testmonial15,
//     name: 'Sushant Dobhal',
//     designation:'KR Mangalam University',
//     text: 'Mastering HTML, CSS, and JavaScript gave me the skills to create responsive, interactive websites. The hands-on exercises and focus on concepts like semantic HTML and CSS styling built a strong foundation in frontend development. The emphasis on responsive design boosted my confidence and equipped me for success in web development.',
//     alt: 'Sushant Dobhal',
//     title: 'Sushant Dobhal',
//     rating: 5,
//   },
//   {
//     img: testmonial14,
//     name: 'Sandli Choudhary',
//     designation:'Lovely Professional University',
//     text: 'The training was valuable and well-organized, with interactive sessions that kept me engaged. I feel more confident in applying the new knowledge, but adding more hands-on exercises and real-world examples would improve the experience. Im grateful for the opportunity and look forward to future sessions.',
//     alt: 'Sandli Choudhary ',
//     title: 'Sandli Choudhary',
//     rating: 5,
//   },
//   {
//     img: testmonial13,
//     name: 'Udayveer Singh Chaudhary',
//     designation: 'Lovely Professional University',
//     text: 'I had a great experience in the Web Development Traineeship Program at InternsElite. The hands-on training with HTML, CSS, and JavaScript, plus mentor feedback, really improved my skills. Working on a real e-commerce project helped me apply what I learned. I highly recommend InternsElite for practical web development experience.',
//     alt: 'Udayveer Singh Chaudhary',
//     title: 'Udayveer Singh Chaudhary',
//     rating: 5,
//   },
//   {
//     img: testmonial12,
//     name: 'Tohuto Sema',
//     designation: 'IIT Kharagpur',
//     text: 'During my web development internship with InternsElite, I gained hands-on experience that improved my skills. The program gave me exposure to various web technologies and real-world projects, all while receiving great support from mentors. It was a rewarding experience that boosted my confidence in the field.',
//     alt: 'Tohuto Sema',
//     title: 'Tohuto Sema',
//     rating: 5,
//   },
//   {
//     img: testmonial11,
//     name: 'Aftab Afzal Pagarkar',
//     designation: 'Pillai College of Arts',
//     text: 'My experience with InternsElite has been truly enriching. I gained a deeper understanding of several concepts that were unfamiliar to me before, and the online learning approach made everything easier to grasp. It was amazing to be a part of this program, and I enjoyed every day of the learning journey.',
//     alt: 'Aftab Afzal Pagarkar',
//     title: 'Aftab Afzal Pagarkar',
//     rating: 5,
//   },
//   {
//     img: testmonial17,
//     name: 'Akansha Singh ',
//     designation:'College of Engineering, Bhubaneswar',
//     text: 'I learned about real-life applications of data science models at InternsElite and received valuable interview preparation. Our mentor was patient, making lessons manageable. Im very satisfied with my overall experience!.',
//     alt: 'Akansha Singh ',
//     title: 'Akansha Singh ',
//     rating: 5,
//   },
//   {
//     img: testmonial19,
//     name: 'Sudiksha Singh',
//     designation: 'Devbhoomi Uttarakhand University',
//     text: 'The training at InternsElite provided a solid Web Development foundation with engaging tasks. Mentors were supportive, enhancing my learning. More structured workshops and diverse projects would improve the program.',
//     alt: 'Sudiksha Singh',
//     title: 'Sudiksha Singh',
//     rating: 4,
//   },
//   {
//     img: testmonial4,
//     name: 'Gagan Deep k',
//     designation: 'VVIT CSE',
//     text: 'It was very good experience training in the company and which helped me improve my skills and knowledge. The company provided very good knowledge on the field of training and about new technology in the professional field.',
//     alt: 'Gagan deep k',
//     title: 'Gagan deep k',
//     rating: 5,
//   },
//   {
//     img: testmonial5,
//     name: 'Devesh Kumar',
//     designation: 'Dr. V S Institute of Computer Studies',
//     text: 'The training provided by Internselite was conducted in a very professional and highly intellectual way. Our mentor was very helpful and handled the course with utmost professionalism.',
//     alt: 'Devesh Kumar',
//     title: 'Devesh Kumar',
//     rating: 4,
//   },
//   {
//     img: testmonial18,
//     name: 'Ipsita Patra',
//     designation: 'ITER',
//     text: 'The feedback that I would like to provide is that is quite good for enhancing the skills of the student which would add to their resume.',
//     alt: 'Ipsita Patra',
//     title: 'Ipsita Patra',
//     rating: 4,
//   },
//   {
//     img: testmonial6,
//     name: 'Abanti Mukherjee',
//     designation: 'Techno India University (BCA)',
//     text: 'The feedback that I would like to provide is that is quite good for enhancing the skills of the student which would add to their resume.',
//     alt: 'Abanti Mukherjee',
//     title: 'Abanti Mukherjee',
//     rating: 4,
//   },
//   {
//     img: testmonial7,
//     name: 'Kolan Ritwik Reddy',
//     designation: 'Vardhaman College Of Engineering, AI&ML Branch',
//     text: 'A big thank you to my course instructors and the Internselite team for guiding me through NMP, HTTrack, IP protocols, and Neural Networks, and for their invaluable support with my projects. Your dedication has been crucial to my success.',
//     alt: 'Kolan Ritwik Reddy',
//     title: 'Kolan Ritwik Reddy',
//     rating: 5,
//   },
//   {
//     img: testmonial8,
//     name: 'Sachin Mishra',
//     designation: 'Gl Bajaj and Computer Science',
//     text: 'Internselite has profoundly transformed my data science journey with its comprehensive training and expert guidance. The platform not only sharpened my technical skills but also enhanced my professional acumen, making it highly recommended for anyone in AI and data science.',
//     alt: 'Sachin Mishra',
//     title: 'Sachin Mishra',
//     rating: 5,
//   },
//   {
//     img: testmonial9,
//     name: 'Ashwajit Manikrao Raut',
//     designation: 'Bapurao Deshmukh College of Engineering',
//     text: 'The InternsElite program was excellent, providing hands-on projects and valuable mentorship that boosted my skills and confidence. I highly recommend it for anyone looking for a top-notch internship experience.',
//     alt: 'Ashwajit Manikrao Raut',
//     title: 'Ashwajit Manikrao Raut',
//     rating: 5,
//   },
//   {
//     img: testmonial10,
//     name: 'Krrish Butola',
//     designation: 'University School of Management and Entrepreneurship , Delhi Technological University',
//     text: 'My Digital Marketing internship at Internselite was invaluable, enhancing my skills in content creation, social media analysis, and SEO with hands-on experience and guidance from Sunanda B. The support and practical tools provided have prepared me well for my future career in digital marketing.',
//     alt: 'Krrish Butola',
//     title: 'Krrish Butola',
//     rating: 5,
//   },
//   {
//     img: testmonial1,
//     name: 'Pranaav B V',
//     designation: 'Vellore Institute of Technology',
//     text: 'It was a good experience. The interactions both on and off class hours were what really impressed me. Be it any time of the day, both the teacher and the representative are present to clarify your doubts and help you however possible.',
//     alt: 'Pranaav B V',
//     title: 'Pranaav B V',
//     rating: 4,
//   },
//   {
//     img: testmonial2,
//     name: 'Vaibhav Gupta',
//     designation: 'SSIPMT RAIPUR CSE',
//     text: 'I like to thank that I was offered exemplary quality training and I was constantly examining my own practice to improve our program overall training of good',
//     alt: 'Vaibhav Gupta',
//     title: 'Vaibhav Gupta',
//     rating: 4,
//   },
//   {
//     img: testmonial3,
//     name: 'Kajal Mishra',
//     designation: 'Manav rachna University',
//     text: 'Overall, I found the program to be highly valuable and well-structured, and I appreciate the opportunity to have been a part of it. I am grateful for the mentorship provided throughout the internship.',
//     alt: 'Kajal Mishra',
//     title: 'Kajal Mishra',
//     rating: 4,
//   },
// ];


// const Review_Component = () => {
//   const settings = {
//     dots:false,
//     infinite: true,
//     speed: 1000,
//     slidesToShow: 2,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed:800,
//     vertical: true,
//     verticalSwiping: true,
//   };

//   return (
//     <>
//     <style>{`
//         .testimonial-card-hight{
//         height:67vh;
//         }
//         .testimonial-card {
//         text-align: center;
//         padding: 2rem;
//         border-radius: 10px;
//         box-shadow: 0 4px 8px rgba(0,0,0,0.1);
//         }
//         .profile {
//         width:95%;
//         height:90px;
//         border-radius: 50%;
//         }
//         .tab_profile{
//         width:80%;
//         border-radius: 50%;
//         }
//         .Mobile_profile{
//         width:30%;
//         border-radius: 50%;
//         }
//         .name {
//         font-size:18px;
//         font-family:"Poppins", sans-serif;
//         user-select: none;
//         }
//         .Tab_name {
//         font-size:15px;
//         font-family:"Poppins", sans-serif;
//         user-select: none;
//         }
//         .designation{
//         color: #777;
//         font-size:12px;
//         font-family:"Poppins", sans-serif;
//         user-select: none;
//         }
//         .Tab_designation{
//         color: #777;
//         font-size:13px;
//         font-family:"Poppins", sans-serif;
//         user-select: none;
//         }
//         .testimonial {
//         color: #777;
//         font-size:10px;
//         font-family:"Poppins", sans-serif;
//         user-select: none;
//         }
//         .Tab_testimonial {
//         color: #777;
//         font-size:10px;
//         font-family:"Poppins", sans-serif;
//         user-select: none;
//         }
//         .textmonial_text h1{
//         font-size:40px;
//         font-family:"Poppins", sans-serif;
//         color: var(--color-grey-darken-2);
//         user-select: none;
//         } 
        // .textmonial_text h2{
        
        // color:#2b1c50;
        // font-family:"Poppins", sans-serif;
        // user-select: none;
        // } 
        // .textmonial_text p{
        // font-size:15px;
        // font-family:"Poppins", sans-serif;
        // color:var(--color-grey-darken-2);
        // user-select: none;
        // }
//       `}</style>
//       {/* ---------------------------Desktop View----------------------- */}
//       <div className="container mt-4">
//         <div className="row">
//           <div className="col-md-6 pt-3 d-none d-md-block">
//             <div className='pt-5 textmonial_text'>
//               <h2>Testimonials</h2>
//               <h2 className='display-3 py-3 '>Our Student's are Saying</h2>
//               <p>Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
//             </div>
//             <div className='d-flex justify-content-start pt-4'>
//               <AvatarGroup max={5}>
//               <Avatar alt="Sachin Mishra" src={testmonial8} />
//                 <Avatar alt="Sudiksha Singh" src={testmonial9} />
//                 <Avatar alt="Patakunti Lakshmi Bhargav Reddy" src={testmonial19} />
//                 <Avatar alt="Sandli Choudhary" src={testmonial14} />
//                 <Avatar alt="Udayveer Singh Chaudhary" src={testmonial13} />
//                 <Avatar alt="Palak Ashok Soshte" src={testmonial16} />
//                 <Avatar alt="Aftab Afzal Pagarkar" src={testmonial11} />
//                 <Avatar alt="Krrish Butola" src={testmonial10} />
//                 <Avatar alt="Abanti Mukherjee" src={testmonial5} />
//                 <Avatar alt="Abanti Mukherjee" src={testmonial6} />
//                 <Avatar alt="Kolan Ritwik Reddy" src={testmonial7} />
//                 <Avatar alt="Remy Sharp" src={testmonial1} />
//                 <Avatar alt="Travis Howard" src={testmonial2} />
//                 <Avatar alt="Cindy Baker" src={testmonial3} />
//                 <Avatar alt="Agnes Walker" src={testmonial4} />
//               </AvatarGroup>
//             </div>
//             <div className='pt-2'>
//               <Rating name="half-rating-read" defaultValue={4.5} precision={0.5} readOnly />
//             </div>
//           </div>
//           <div className="col-md-6 px-4 d-xl-block d-none">
//             <div className="">
//               <Slider className='testimonial-card-hight' {...settings}>
//                 {testimonials.map((testimonial, index) => (
//                   <div
//                     className="my-3 testimonial-card px-5 py-3"
//                     key={index}
//                   >
//                     <div className="container">
//                       <div className="row">
//                         <div className="col-3">
//                           <div className='d-flex justify-content-start'>
//                             <img
//                               src={testimonial.img}
//                               alt={testimonial.alt}
//                               className="profile mt-4"
//                               onContextMenu={(e) => e.preventDefault()}
//                             />
//                           </div>
//                           <div className='pt-2'>
//                             <Rating name="size-small" value={testimonial.rating} size="small" precision={0.5} readOnly />
//                           </div>
//                         </div>
//                         <div className='col-1'></div>
//                         <div className="col-8 my-3">
//                           <h2 className="name">{testimonial.name}</h2>
//                           <h2 className="designation">
//                             {testimonial.designation}
//                           </h2>
//                           <p className="testimonial"><ImQuotesLeft size="10px"/>{' '}{testimonial.text}{' '}<ImQuotesRight size="10px" /></p>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </Slider>
//             </div>
//           </div>
//           <div className="col-md-6 d-md-block d-none d-xl-none">
//             <div className="">
//               <Slider className='' {...settings}>
//                 {testimonials.map((testimonial, index) => (
//                   <div
//                     className="my-3 testimonial-card px-3 py-3"
//                     key={index}
//                   >
//                     <div className="container">
//                       <div className="row">
//                         <div className="col-3">
//                           <div className='d-flex justify-content-start'>
//                             <img
//                               src={testimonial.img}
//                               alt={testimonial.alt}
//                               className="tab_profile mt-4"
//                               onContextMenu={(e) => e.preventDefault()}
//                             />
//                           </div>
//                           <div className='pt-2'>
//                             <Rating name="size-small" value={testimonial.rating} size="small" precision={0.5} readOnly />
//                           </div>
//                         </div>
//                         <div className='col-1'></div>
//                         <div className="col-8 my-3">
//                           <h2 className="Tab_name pt-3">{testimonial.name}</h2>
//                           <h2 className="Tab_designation">
//                             {testimonial.designation}
//                           </h2>
//                           <p className="Tab_testimonial"><ImQuotesLeft size="10px"/>{' '}{testimonial.text}{' '}<ImQuotesRight size="10px" /></p>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </Slider>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* ---------------------------Mobile View----------------------- */}
//       <div className="container d-md-none d-sm-block mt-2">
//         <div className="row">
//           <div className="col-md-12 pt-3 text-center">
//             <div className='textmonial_text'>
//               <h2>Testimonials</h2>
//               <h2 className='display-3 py-2'>Our Student's are Saying</h2>
//               <p>Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
//             </div>
//             <div className='d-flex justify-content-center pt-2'>
//             <AvatarGroup max={5}>
//               <Avatar alt="Sachin Mishra" src={testmonial8} />
//                 <Avatar alt="Sudiksha Singh" src={testmonial9} />
//                 <Avatar alt="Patakunti Lakshmi Bhargav Reddy" src={testmonial19} />
//                 <Avatar alt="Sandli Choudhary" src={testmonial14} />
//                 <Avatar alt="Udayveer Singh Chaudhary" src={testmonial13} />
//                 <Avatar alt="Palak Ashok Soshte" src={testmonial16} />
//                 <Avatar alt="Aftab Afzal Pagarkar" src={testmonial11} />
//                 <Avatar alt="Krrish Butola" src={testmonial10} />
//                 <Avatar alt="Abanti Mukherjee" src={testmonial5} />
//                 <Avatar alt="Abanti Mukherjee" src={testmonial6} />
//                 <Avatar alt="Kolan Ritwik Reddy" src={testmonial7} />
//                 <Avatar alt="Remy Sharp" src={testmonial1} />
//                 <Avatar alt="Travis Howard" src={testmonial2} />
//                 <Avatar alt="Cindy Baker" src={testmonial3} />
//                 <Avatar alt="Agnes Walker" src={testmonial4} />
//               </AvatarGroup>
//             </div>
//             <div className='pt-2'>
//             <Rating name="half-rating-read" defaultValue={4.5} precision={0.5} readOnly />
//             </div>
//           </div>
//           <div className="col-md-12">
//             <div className="">
//               <Slider className='' {...settings}>
//                 {testimonials.map((testimonial, index) => (
//                   <div
//                     className="my-3 testimonial-card px-2 py-3"
//                     key={index}
//                   >
//                     <div className="container-fluid">
//                       <div className="row">
//                         <div className="col-12">
//                           <div className='d-flex justify-content-center'>
//                             <img
//                               src={testimonial.img}
//                               alt={testimonial.alt}
//                               className="Mobile_profile mt-4"
//                               onContextMenu={(e) => e.preventDefault()}
//                             />
//                           </div>
//                           <div className='pt-2'>
//                             <Rating name="size-small" value={testimonial.rating} size="small" precision={0.5} readOnly />
//                           </div>
//                         </div>
//                         <div className="col-12 my-3">
//                           <h2 className="Tab_name">{testimonial.name}</h2>
//                           <h2 className="Tab_designation">
//                             {testimonial.designation}
//                           </h2>
//                           <p className="Tab_testimonial"><ImQuotesLeft size="10px"/>{' '}{testimonial.text}{' '}<ImQuotesRight size="10px" /></p>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </Slider>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };
// export default Review_Component;


import React, { useState, useEffect } from "react";
import { FaStar } from "react-icons/fa";
import testmonial1 from '../Image/testmonial1.webp';
import testmonial2 from '../Image/testmonial2.webp';
import testmonial3 from '../Image/testmonial3.webp';
import testmonial4 from '../Image/testmonial4.webp';
import testmonial5 from '../Image/testmonial5.webp';
import testmonial6 from '../Image/testmonial6.webp';
import testmonial7 from '../Image/testmonial7.webp';
import testmonial8 from '../Image/testmonial8.webp';
import testmonial9 from '../Image/testmonial9.webp';
import testmonial10 from '../Image/testmonial10.webp';
import testmonial11 from '../Image/testmonial11.webp';
import testmonial12 from '../Image/testmonial12.webp';
import testmonial13 from '../Image/testmonial13.webp';
import testmonial14 from '../Image/testmonial14.webp';
import testmonial15 from '../Image/testmonial15.webp';
import testmonial16 from '../Image/testmonial16.webp';
import testmonial17 from '../Image/testmonial17.webp';
import testmonial18 from '../Image/testmonial18.webp';
import testmonial19 from '../Image/testmonial19.webp';

const testimonials = [
    {
    img: testmonial16,
    name: 'Palak Ashok Soshte',
    institution:'B K Birla College',
    feedback: 'During my internship, I gained hands-on experience with sensors, enhancing my understanding of robotics. I applied coursework concepts to solve real-world problems and developed strong technical skills in model creation. This experience improved my teamwork and communication skills, confirming my desire to pursue a career in robotics.',
    alt: 'Palak Ashok Soshte ',
    title: 'Palak Ashok Soshte ',
    stars: 5,
  },
  {
    img: testmonial15,
    name: 'Sushant Dobhal',
    institution:'KR Mangalam University',
    feedback: 'Mastering HTML, CSS, and JavaScript gave me the skills to create responsive, interactive websites. The hands-on exercises and focus on concepts like semantic HTML and CSS styling built a strong foundation in frontend development. The emphasis on responsive design boosted my confidence and equipped me for success in web development.',
    alt: 'Sushant Dobhal',
    title: 'Sushant Dobhal',
    stars: 5,
  },
  {
    img: testmonial14,
    name: 'Sandli Choudhary',
    institution:'Lovely Professional University',
   feedback: 'The training was valuable and well-organized, with interactive sessions that kept me engaged. I feel more confident in applying the new knowledge, but adding more hands-on exercises and real-world examples would improve the experience. Im grateful for the opportunity and look forward to future sessions.',
    alt: 'Sandli Choudhary ',
    title: 'Sandli Choudhary',
    stars: 5,
  },
  {
    img: testmonial13,
    name: 'Udayveer Singh Chaudhary',
    institution: 'Lovely Professional University',
    feedback: 'I had a great experience in the Web Development Traineeship Program at InternsElite. The hands-on training with HTML, CSS, and JavaScript, plus mentor feedback, really improved my skills. Working on a real e-commerce project helped me apply what I learned. I highly recommend InternsElite for practical web development experience.',
    alt: 'Udayveer Singh Chaudhary',
    title: 'Udayveer Singh Chaudhary',
    stars: 5,
  },
  {
    img: testmonial12,
    name: 'Tohuto Sema',
    institution: 'IIT Kharagpur',
    feedback: 'During my web development internship with InternsElite, I gained hands-on experience that improved my skills. The program gave me exposure to various web technologies and real-world projects, all while receiving great support from mentors. It was a rewarding experience that boosted my confidence in the field.',
    alt: 'Tohuto Sema',
    title: 'Tohuto Sema',
    stars: 5,
  },
  {
    img: testmonial11,
    name: 'Aftab Afzal Pagarkar',
    institution: 'Pillai College of Arts',
    feedback: 'My experience with InternsElite has been truly enriching. I gained a deeper understanding of several concepts that were unfamiliar to me before, and the online learning approach made everything easier to grasp. It was amazing to be a part of this program, and I enjoyed every day of the learning journey.',
    alt: 'Aftab Afzal Pagarkar',
    title: 'Aftab Afzal Pagarkar',
    stars: 5,
  },
  {
    img: testmonial17,
    name: 'Akansha Singh ',
    institution:'College of Engineering, Bhubaneswar',
    feedback: 'I learned about real-life applications of data science models at InternsElite and received valuable interview preparation. Our mentor was patient, making lessons manageable. Im very satisfied with my overall experience!.',
    alt: 'Akansha Singh ',
    title: 'Akansha Singh ',
    stars: 5,
  },
  {
    img: testmonial19,
    name: 'Sudiksha Singh',
    institution: 'Devbhoomi Uttarakhand University',
    feedback: 'The training at InternsElite provided a solid Web Development foundation with engaging tasks. Mentors were supportive, enhancing my learning. More structured workshops and diverse projects would improve the program.',
    alt: 'Sudiksha Singh',
    title: 'Sudiksha Singh',
    stars: 4,
  },
  {
    img: testmonial4,
    name: 'Gagan Deep k',
    institution: 'VVIT CSE',
    feedback: 'It was very good experience training in the company and which helped me improve my skills and knowledge. The company provided very good knowledge on the field of training and about new technology in the professional field.',
    alt: 'Gagan deep k',
    title: 'Gagan deep k',
    stars: 5,
  },
  {
    img: testmonial5,
    name: 'Devesh Kumar',
    institution: 'Dr. V S Institute of Computer Studies',
    feedback: 'The training provided by Internselite was conducted in a very professional and highly intellectual way. Our mentor was very helpful and handled the course with utmost professionalism.',
    alt: 'Devesh Kumar',
    title: 'Devesh Kumar',
    stars: 4,
  },
  {
    img: testmonial18,
    name: 'Ipsita Patra',
    institution: 'ITER',
    feedback:'The feedback that I would like to provide is that is quite good for enhancing the skills of the student which would add to their resume.',
    alt: 'Ipsita Patra',
    title: 'Ipsita Patra',
    stars: 4,
  },
  {
    img: testmonial6,
    name: 'Abanti Mukherjee',
    institution: 'Techno India University (BCA)',
    feedback: 'The feedback that I would like to provide is that is quite good for enhancing the skills of the student which would add to their resume.',
    alt: 'Abanti Mukherjee',
    title: 'Abanti Mukherjee',
    stars: 4,
  },
  {
    img: testmonial7,
    name: 'Kolan Ritwik Reddy',
    institution: 'Vardhaman College Of Engineering, AI&ML Branch',
    feedback: 'A big thank you to my course instructors and the Internselite team for guiding me through NMP, HTTrack, IP protocols, and Neural Networks, and for their invaluable support with my projects. Your dedication has been crucial to my success.',
    alt: 'Kolan Ritwik Reddy',
    title: 'Kolan Ritwik Reddy',
    stars: 5,
  },
  {
    img: testmonial8,
    name: 'Sachin Mishra',
    institution: 'Gl Bajaj and Computer Science',
    feedback: 'Internselite has profoundly transformed my data science journey with its comprehensive training and expert guidance. The platform not only sharpened my technical skills but also enhanced my professional acumen, making it highly recommended for anyone in AI and data science.',
    alt: 'Sachin Mishra',
    title: 'Sachin Mishra',
    stars: 5,
  },
  {
    img: testmonial9,
    name: 'Ashwajit Manikrao Raut',
    institution: 'Bapurao Deshmukh College of Engineering',
    feedback: 'The InternsElite program was excellent, providing hands-on projects and valuable mentorship that boosted my skills and confidence. I highly recommend it for anyone looking for a top-notch internship experience.',
    alt: 'Ashwajit Manikrao Raut',
    title: 'Ashwajit Manikrao Raut',
    stars: 5,
  },
  {
    img: testmonial10,
    name: 'Krrish Butola',
    institution: 'University School of Management and Entrepreneurship , Delhi Technological University',
    feedback: 'My Digital Marketing internship at Internselite was invaluable, enhancing my skills in content creation, social media analysis, and SEO with hands-on experience and guidance from Sunanda B. The support and practical tools provided have prepared me well for my future career in digital marketing.',
    alt: 'Krrish Butola',
    title: 'Krrish Butola',
    stars: 5,
  },
  {
    img: testmonial1,
    name: 'Pranaav B V',
    institution: 'Vellore Institute of Technology',
    feedback: 'It was a good experience. The interactions both on and off class hours were what really impressed me. Be it any time of the day, both the teacher and the representative are present to clarify your doubts and help you however possible.',
    alt: 'Pranaav B V',
    title: 'Pranaav B V',
    stars: 4,
  },
  {
    img: testmonial2,
    name: 'Vaibhav Gupta',
    institution: 'SSIPMT RAIPUR CSE',
    feedback: 'I like to thank that I was offered exemplary quality training and I was constantly examining my own practice to improve our program overall training of good',
    alt: 'Vaibhav Gupta',
    title: 'Vaibhav Gupta',
    stars: 4,
  },
  {
    img: testmonial3,
    name: 'Kajal Mishra',
    institution: 'Manav rachna University',
    feedback: 'Overall, I found the program to be highly valuable and well-structured, and I appreciate the opportunity to have been a part of it. I am grateful for the mentorship provided throughout the internship.',
    alt: 'Kajal Mishra',
    title: 'Kajal Mishra',
    stars: 4,
  },

];


function ReviewCard({ testimonial, isHovered, animate }) {
  return (
    <div
      className={`review-card ${!isHovered && animate ? "fade-effect" : ""}`}
      style={{
        transform: isHovered ? "translateY(-15px)" : "translateY(0)",
        transition: "all 0.3s ease",
      }}
    >
      <div className="d-flex align-items-center mb-3">
        <img 
          src={testimonial.img} 
          alt={testimonial.alt} 
          className="testimonial-img" 
          onContextMenu={(e) => e.preventDefault()} 
        />
        <div className="ms-3">
          <h5 className="fw-bold mb-0">{testimonial.name}</h5>
          <small>{testimonial.institution}</small>
        </div>
      </div>
      <div className="stars mb-2">
        {Array.from({ length: 5 }, (_, i) => (
          <FaStar key={i} color={i < testimonial.stars ? "gold" : "#ccc"} />
        ))}
      </div>
      <p className="mb-0">{testimonial.feedback}</p>
    </div>
  );
}


function Review_Component() {
 
const maxCards = 3;  
const initialIndexes = testimonials.length >= maxCards
    ? [0, 1, 2]
    : Array.from({ length: testimonials.length }, (_, i) => i);

const [indexes, setIndexes] = useState(initialIndexes);
 const [hoveredIndex, setHoveredIndex] = useState(null);
const [animateFlags, setAnimateFlags] = useState(initialIndexes.map(() => false));

  useEffect(() => {
    const interval = setInterval(() => {
      setIndexes((prev) =>
        prev.map((val, i) => {
          if (i === hoveredIndex) {
            
            return val;
          } else {
            
            let nextVal = (val + 1) % testimonials.length;

            
            if (hoveredIndex !== null && nextVal === prev[hoveredIndex]) {
              nextVal = (nextVal + 1) % testimonials.length;
            }
            return nextVal;
          }
        })
      );

     
      setAnimateFlags((prev) =>
        prev.map((_, i) => (i === hoveredIndex ? false : true))
      );

      
      setTimeout(() => {
        setAnimateFlags((prev) =>
          prev.map((_, i) => (i === hoveredIndex ? false : false))
        );
      }, 600);
    }, 3500);

    return () => clearInterval(interval);
  }, [hoveredIndex]);

  return (
    <div className="container py-5 text-center">
      <h2 className="display-5 fs-1 fw-custom textmonial_text mb-2">Testimonials</h2>
      <p className="fs-5 fw-text mb-5">
      Students share their success journeys with us.
      </p>

      <div className="review-row">
  {indexes.map((idx, i) => {
    const testimonial = testimonials[idx];
    if (!testimonial) return null; 
    return (
      <div
        key={i}
        onMouseEnter={() => setHoveredIndex(i)}
        onMouseLeave={() => setHoveredIndex(null)}
      >
        <ReviewCard
          testimonial={testimonial}
          isHovered={hoveredIndex === i}
          animate={animateFlags[i]}
        />
      </div>
    );
  })}
</div>
      <style>{`
        .review-row {
          display: flex;
          justify-content: center;
          gap: 30px;
          flex-wrap: wrap;
        }
        .review-card {
          background: #fff;
          border-radius: 16px;
         
          box-shadow: 0 6px 16px rgba(0,0,0,0.12);
          padding: 30px;
          width: 400px;
          min-height: 400px;
          text-align: left;
          transition: all 0.3s ease;
          user-select: none;
        }
        .review-card:hover {
          transform: translateY(-15px);
        }
        .testimonial-img {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          object-fit: cover;
        }

         
        .fw-custom {
           font-weight: 400;
           font-family:"Poppins", sans-serif;
           color:#2b1c50;
           font-size:35px; 
           user-select: none;
         }
        .fw-text p{
        font-size:15px;
        font-family:"Poppins", sans-serif;
        color:var(--color-grey-darken-2);
        user-select: none;
        }

        .fade-effect {
          background-color: #f0f8ff; /* only for rotating cards */
        }
        .stars { font-size: 20px; }


        /* ------------------- MOBILE VIEW ------------------- */
  @media (max-width: 768px) {
    .review-row {
      flex-direction: column;
      gap: 20px;
      align-items: center;
    }
    .review-card {
      width: 90%; 
      padding: 20px;
      
      min-height: auto; /* height auto adjust */
      margin-left: 15px;
    }
    .testimonial-img {
      width: 60px;
      height: 60px;
    }
    .fw-custom {
      font-size: 28px;
    }
    .fw-text p {
      font-size: 14px;
    }
  }
      `}
      </style>
    </div>
  );
}

export default Review_Component;








